import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { LoadingPanel } from "../../LoadingPanel";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

import {
    FormInput,
    FormCheckbox,
} from "../../forms/form-components";

import './Performer.scss';

export const AdministratorPerformer = (props) => {
    const dispatch = useDispatch();

    const [selectedTab, setSelectedTab] = useState(0);

    const nameValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        if (value.length > 100) {
            return "Maximum length is 100 characters";
        }

        return "";
    }

    const handleSubmit = (dataItem) => {
        let fetchMethod, successMessage;

        if (!dataItem.performerKey) {
            //Create new performer
            fetchMethod = "POST";
            successMessage = "Created item successfully";
        }
        else {
            //Update existing performer
            fetchMethod = "PUT";
            successMessage = "Updated item successfully";
        }

        fetch("/api/administrator/performer",
            {
                method: fetchMethod,
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", successMessage);

                props.selectPerformer(result.performerKey);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const deletePerformer = (performerKey) => {
        if (window.confirm("Are you sure you want to delete this item?") === false) {
            return;
        }

        const dataItem = {
            "performerKey": performerKey
        }

        fetch("/api/administrator/performer",
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Deleted item successfully");

                props.cancel();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const tabStripSelectionChanged = (e) => {
        setSelectedTab(e.selected);
    };

    const getForm = (performer) => {
        if (!performer) {
            performer = {
                isActive: true,
            }
        }

        if (!performer?.performerKey && selectedTab > 0) {
            //Cannot have selected tab be a disabled one
            setSelectedTab(0);
        }

        return (
            <div className="administratorPerformer">
                <TabStrip selected={selectedTab} onSelect={tabStripSelectionChanged}>
                    <TabStripTab title={"Performer"}>
                        <Form
                            onSubmit={handleSubmit}
                            initialValues={performer}
                            key={JSON.stringify(performer)}
                            render={(formRenderProps) => (
                                <FormElement>
                                    <h2>
                                        {!performer?.performerKey ? "New Performer" : "Update Performer"}
                                    </h2>
                                    
                                    <fieldset className={"k-form-fieldset"}>
                                        {!performer?.performerKey ? "" :
                                            (<div className="mb-3 noFormField">
                                                <Label>Key:</Label> {performer.performerKey}
                                            </div>)
                                        }

                                        {!performer?.performerKey ? "" :
                                            (<div className="mb-3 noFormField">
                                                <Label>Created:</Label> {performer.dateCreated}
                                            </div>)
                                        }

                                        <Field
                                            id={"isActive"}
                                            name={"isActive"}
                                            label={"Active"}
                                            component={FormCheckbox}
                                        />

                                        <Field
                                            id={"name"}
                                            name={"name"}
                                            label={"Name"}
                                            component={FormInput}
                                            validator={nameValidator}
                                        />
                                    </fieldset>
                                    <span className={"k-form-separator"} />
                                    <div className="k-form-buttons">
                                        <Button
                                            themeColor={"primary"}
                                            type={"submit"}
                                            disabled={!formRenderProps.allowSubmit}
                                            >
                                            Save
                                        </Button>

                                        {!performer?.performerKey ? null :
                                            (<Button
                                                type={"button"}
                                                className={"deleteButton"}
                                                onClick={() => deletePerformer(performer.performerKey)}>
                                                Delete
                                            </Button>
                                        )}
                                    </div>
                                </FormElement>
                            )}
                        />
                    </TabStripTab>
                </TabStrip>
                <div className="administratorPerformerClose">
                    <Button
                        themeColor={"primary"}
                        type={"button"}
                        onClick={props.cancel}
                    >
                        Close
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <>
            { props.loading === true ? <LoadingPanel /> : (props.createNewPerformer === true ? getForm() : (props.performer ? getForm(props.performer) : <div></div>))}
        </>
    );
}